import React, { createContext, useState } from 'react';
import { PageContextType } from '.';

type PageContextProps = {
  pageContext: PageContextType | undefined;
  setPageContext: React.Dispatch<
    React.SetStateAction<PageContextType | undefined>
  >;
};

type PageContextPropsValidated = {
  pageContext: PageContextType;
  setPageContext: React.Dispatch<React.SetStateAction<PageContextType>>;
};

type PageContextProviderProps = {
  children?: React.ReactNode;
  initialValue?: PageContextType;
}
export const PageContext = createContext<PageContextProps>(
  {
    pageContext: undefined,
    setPageContext: () => {},
  }
);

export const PageContextProvider = ({ children, initialValue }: PageContextProviderProps) => {
  const [pageContext, setPageContext] = useState<PageContextType | undefined>(initialValue);

  return (
    <PageContext.Provider
      value={{
        pageContext,
        setPageContext,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const usePageContext = (): PageContextPropsValidated => {
  const context = React.useContext(PageContext);

  if (!context || !context.pageContext) {
    throw new Error('No host context found. Please setup the PageContext');
  }

  return context as PageContextPropsValidated;
};
